import { render, staticRenderFns } from "./switchPlan.vue?vue&type=template&id=0e67806e&scoped=true&"
import script from "./switchPlan.vue?vue&type=script&lang=js&"
export * from "./switchPlan.vue?vue&type=script&lang=js&"
import style0 from "./switchPlan.vue?vue&type=style&index=0&id=0e67806e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e67806e",
  null
  
)

export default component.exports